import type { RouteObject } from "react-router";
import { MODERATION_ROUTES } from "../constants/moderation-routes";

export const moderationRoutes: RouteObject = {
	children: [
		{
			path: MODERATION_ROUTES.ROOT,
			lazy: async () => {
				const { default: ModerationPage } = await import("../pages/moderation-page");
				return { Component: ModerationPage };
			},
		},
	],
};
